// Mapping for the server activity kind `file_edited` (one entry per new Markdown version, none for merged saves;
// payload: { file: { id, name, size, mime }, version_no, restored_from }). For the integrator to add a case in
// src/sync/activity.ts `activityToLog`, next to `file_attached` / `file_removed` (same "Files" field label).
import type { LogChange } from '@/domain/model';

export function fileEditedChange(changes: Record<string, unknown>): LogChange | null {
  const f = changes.file as { id?: unknown; name?: unknown } | undefined;
  const name = typeof f?.name === 'string' ? f.name : '';
  if (!name) return null;
  const n = typeof changes.version_no === 'number' ? changes.version_no : null;
  const from = typeof changes.restored_from === 'number' ? changes.restored_from : null;
  const after = name + (from !== null ? ' · restored version ' + from : n !== null ? ' · version ' + n : '');
  return { f: 'files', label: 'Files', b: name, a: after };
}
